module.exports = __webpack_public_path__ + "media/images/magic-spoon-ce411f2b9852531e9b5166a426a1e1b4.png";